<template>
	<a
		class="site_button"
		:class="[theme, type, (is_hovered ? 'is_hovered' : null)]"
		:href="parsedLink ? parsedLink.url : null"
		:target="parsedLink ? parsedLink.target : null"
		@mouseenter="hovered = true"
		@mouseleave="hovered = false"
		ref="site_button"
	>

		<span class="hover_arrow">&rarr;</span>

		<span v-html="button_label ? button_label : parsedLink.title"></span>

		<span class="arrow">&rarr;</span>

	</a>
</template>

<script>
export default {
	data() {
		return {
			button_label: this.label,
			button_link: this.link,
			hovered: false,
		};
	},

	props: {
		link: {},
		label: {},
		is_hovered: {
			type: Boolean,
			default: false,
		},
		target: {},
		theme: {
			default: 'light',
		},
		type: {
			default: 'normal',
		},
	},

	computed: {
		parsedLink() {
			if (typeof this.link === 'object' && this.link !== null) {
				return this.link;
			} else if (!Array.isArray(this.link)) {
				try {
					return JSON.parse(this.link);
				} catch (e) {
					return null;
				}
			} else {
				return null;
			}
		},
	},

	watch: {
		link() {
			this.button_link = this.link;
		},
	},

	methods: {
		checkEmpty(e) {
			if (this.button_link.url === '#') {
				// this.$refs.site_button.removeAttribute('href');
				e.preventDefault();
			}
		},
	},

	components: {},

	created() {},
	mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.site_button {
	display: inline-flex;
	padding: 16px 24px 14px;
	border-radius: 30px;
	text-decoration: none;
	/* height: 60px; */
	display: inline-flex;
	justify-content: flex-start;
	/* align-items: center; */
	transition: 0.2s ease all;
	color: var(--duco-blue);
	border: 1px solid var(--light-grey);
	overflow: hidden;
	min-width: 280px;
	position: relative;

	.stay_in_touch & {
		color: var(--light-grey);
	}

	@media (max-width: $laptop) {
		min-width: auto;
	}

	&.dark {
		color: var(--light-grey);
	}

	@media (hover) {
		&:hover {
			background: var(--duco-blue);
			transition: 0.2s ease all;
			cursor: pointer;

			span {
				color: var(--light-grey);
			}

			.arrow {
				transform: translateX(50px);
				opacity: 0;
				pointer-events: none;
			}

			.hover_arrow {
				transform: translateX(50px);
				opacity: 1;
				pointer-events: none;
			}
		}
	}

	&[is_hovered='true'], &.is_hovered {
		background: var(--duco-blue);
		transition: 0.2s ease all;
		cursor: pointer;

		span {
			color: var(--light-grey);
		}

		.arrow {
			transform: translateX(50px);
			opacity: 0;
			pointer-events: none;
		}

		.hover_arrow {
			transform: translateX(50px);
			opacity: 1;
			pointer-events: none;
		}
	}

	&:disabled {
		opacity: 0.5;
	}

	span {
		font: normal normal normal 16px/16px var(--primary-font-family);
		transition: 0.2s ease all;
		margin-right: 0;
		position: relative;
		z-index: 10;
		margin-left: 20px;
	}

	.arrow {
		position: relative;
		margin-left: 10px;
	}

	.hover_arrow {
		position: absolute;
		left: -50px;
		opacity: 0;
	}
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/PrimaryButton.vue